fragment shiftInstanceInfo on ShiftInstance {
  shiftId
  name
  scheduledStart
  scheduledEnd
  maxLabor
  startingLabor
}
